import type { InjectionKey } from 'vue';
import { inject } from 'vue';

import type { ModalPlugin } from '../types';

export const PLUGIN_KEY = Symbol('MODAL_PLUGIN') as InjectionKey<ModalPlugin>;

export function useModalPlugin() {
  const plugin = inject<ModalPlugin>(PLUGIN_KEY);

  if (!plugin) {
    throw new Error('Inject Request was called before initialization. Did you forget to install ModalPlugin ?');
  }

  return plugin;
}
